<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="btn-type1">
                <el-button type="primary" icon="el-icon-search" @click="selectItem()">
                    검색
                </el-button>
            </div>
            <div class="pop-content-search">
                <el-form size="mini">
                    <el-row :gutter="21">
                        <el-col :span="7">
                            <el-form-item label="고객명">
                                <el-input type="text" v-model.trim="form.custNm" @keyup.native.enter="selectItem"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="전화번호">
                                <el-input type="text" v-model.trim="form.telNo" @keyup.native.enter="selectItem"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="grid-wrap">
                <div class="table-area">
                    <div class="table-b">
                        <ag-grid-vue 
                        style="width: 100%; height: 330px;"
                        class="ag-theme-alpine"    
                        row-selection="single"
                        :framework-components="frameworkComponents"
                        :column-defs="columnDefs"     
                        :grid-options="gridOptions"
                        :row-data="rowData"
                        :default-col-def="defaultColDef"
                        @grid-ready="onGridReady"/>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';
/**
 * Modal index mixin
 */
import mixin from './index';

/**
 * * AG-Grid components
 */
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';

// 숫자에 콤마표시
function comma(val){
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default {
    mixins: [mixin],
    components: {Layout},
    props: {
        data: {
        }
    },
    data() {
        return {
            title: '배송정보조회',
            form: {
                custNm: '',
                telNo: '',
                itemNm: ''
            },
            modelGroupList: [{ key: '', value: '전체' }, { key: '01', value: '컴퓨터' }, { key: '02', value: '모니터' }],
            subModelGroupList: [{ key: '', value: '전체' }, { key: '01', value: '데스크탑' }, { key: '02', value: '노트북' }],
            // AG-GRID OPTION [START]
            rowData:[],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponents : {
                checkbox: CheckboxCellRenderer,
            },
            columnDefs:[
                {
                    headerName:'No', 
                    field:'no', 
                    width:80,
                    cellStyle : {textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    }
                },
                {
                    headerName:'의뢰일자', 
                    field:'dtGir',  
                    width:130,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'수취인', 
                    field:'nmCustDlv', 
                    width:100,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName: '주문자', 
                    field:'nmCust', 
                    width: 100,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName: '주문자전화', 
                    field:'noTel2', 
                    width: 150,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName: '수취인전화', 
                    field:'noTelD2',
                    width: 150,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName: '주소1', 
                    field:'addr1', 
                    width: 200,
                    cellStyle:{textAlign:'left'},
                },
                {
                    headerName: '품목', 
                    field:'cdItem', 
                    width: 170,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName: '품목명(영)', 
                    field:'enItem', 
                    width: 170,
                    cellStyle:{textAlign:'left'},
                },
                {
                    headerName: '품목명', 
                    field:'nmItem', 
                    width: 220,
                    cellStyle:{textAlign:'left'},
                },
                {
                    headerName: '수량', 
                    field:'qtGir', 
                    width: 120,
                    cellStyle:{textAlign:'right'},
                },
                {
                    headerName: '배송상태', 
                    field:'dstate', 
                    width: 120,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName: '수주상태', 
                    field:'staSo', 
                    width: 120,
                    cellStyle:{textAlign:'center'},
                }
            ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            // AG-GRID OPTION [END]
        }
    },
    mounted() {
        //pop slots modal move
        $(".animation-content").addClass('pop_min2');
        $(".animation-content").draggable({'cancel':'.modal-card-body'});
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '4');

        console.log('mounted data: ', this.data);
        this.form.custNm = this.data.custNm || '';
        this.form.telNo = this.data.telNo || '';

        // this.selectItem();
    },
    destroyed() {
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '7');
    },
    methods: {
        changeTab(params) {
            this.viewer = params.tabId;
        },
        closeModal() {
            console.log(this.$parent)
            this.$parent.close();
        },
        handleNodeClick(data) {
            console.log(data);
        },
        onGridReady(){
            
        },
        onCellClicked(params) {
            const field = params.colDef.field;
        },
        selectItem(e){
            /** 검색 */
            const vTelNo = this.form.telNo.replace(/[^0-9]/g, '');

            const vform = {
                custNm: this.form.custNm ? this.form.custNm : '',
                telNo: this.form.telNo ? vTelNo : '',
                itemNm: '',
                sortType: '',
                page: 1,
                totalPage: 9999,
                totalCount: 9999,
                curPage: 0,
                processTime: ''
            }
             
            this.$store.commit('loading')
            console.log('selectItem vform : ', vform) 
            this.$http.post(("/api/asMng/popup/selectDelivery"), vform
                ).then(response => {
                // console.log('selectItem' , response)
                this.rowData = response.data.map(x=>{
                    x.dtGir = x.dtGir && x.dtGir.length >= 8 ? x.dtGir.substring(0,4) + '-' + x.dtGir.substring(4,6) + '-' + x.dtGir.substring(6) : ''; 
                    return x;
                });

            }).finally(() => {
                this.$store.commit('finish')
            });
        }
    }

}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}
</style>